<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Документ</h3>
            </v-flex>
            <v-flex xs12>
                <v-tabs
                        v-model="tab"
                >
                    <v-tab href="#tab-1">
                        Основные данные
                    </v-tab>
                    <v-tab-item
                            :value="'tab-1'">
                        <v-card>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model.trim="card.doc_name"
                                                    label="Наименование документа"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                    v-model="card.doc_date"
                                                    label="Дата документа"
                                                    type="date"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                    v-model.trim="card.doc_num"
                                                    label="Номер документа"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                    v-model="card.commissioning_date"
                                                    label="Дата ввода в эксплуатацию"
                                                    type="date"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model.trim="card.organization_name"
                                                    label="Наименование организации"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-card>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    icon
                                    large
                                    class="mx-2"
                                    @click.native="close"
                            >
                                <v-icon>mdi-cancel</v-icon>
                            </v-btn>
                            <v-btn
                                    icon
                                    large
                                    class="mx-2"
                                    @click.native="save()"
                            >
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                            <v-btn
                                    icon
                                    large
                                    class="mx-2"
                                    @click.native="deleteCard()"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-tab-item>
                    <v-tab href="#tab-2">
                        Системные данные
                    </v-tab>
                    <v-tab-item
                            :value="'tab-2'"
                    >
                        <system-form :system-info="card"></system-form>
                    </v-tab-item>
                </v-tabs>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import SystemForm from '../../common/systemForm'
export default {
  name: 'cardDocument',
  components: { SystemForm },
  data () {
    return {
      tab: 1
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    card () {
      return this.$store.getters['ASDocument/card']
    }
  },
  methods: {
    initialize () {
      this.$store.dispatch('ASDocument/fetchCard', {
        id: this.$route.params.id })
    },
    save (status) {
      this.$store.dispatch('ASDocument/insertCard', this.card)
        .then(() => {
          this.close()
        })
    },
    close () {
      this.$router.go(-1)
    },
    deleteCard (id) {
      this.$store.dispatch('ASDocument/deleteCard', this.card.id)
        .then(() => {
          this.$router.go(-1)
        })
    }
  },
  created: function () {
    if (this.card.id === null && this.$route.params.id !== 'new') {
      this.initialize()
    }
  }
}
</script>
